import script from "./OptionSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./OptionSelector.vue?vue&type=script&setup=true&lang=ts"

import "./OptionSelector.vue?vue&type=style&index=0&id=f084231a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f084231a"]])

export default __exports__